import React, { useRef, useState, useEffect } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { duration, Stack, TextField } from "@mui/material";
import { Message } from "primereact/message";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Toast } from "primereact/toast";
import { Trans, useTranslation } from "react-i18next";
import { Formik, Form, Field } from "formik";
import Lottie from "react-lottie";
import { Tooltip } from "primereact/tooltip";
import infoIcon from "../assets/icons/info.png";
import { useRecoilState } from "recoil";
import {
  SNMG,
  TauxBEA,
  DurationCredit,
  Salary,
  age,
  borrowedCapital,
  PremiumClient,
  TALA,
  TMM,
  hamishEldjedia,
  modalState,
  simulatorState,
} from "../states/atoms/simulator";
import moment from "moment/moment";
import dayjs from "dayjs";
import animationData from "../assets/lottie/95088-success.json";
import { Link } from "react-router-dom";

function Simulator() {
  //todo:simulator state "recoil"

  const [simulatorStateRecoil, setSimulatorStateRecoil] =
    useRecoilState(simulatorState);
  const [durationSimulator, setDurationSimulator] =
    useRecoilState(DurationCredit);
  const [ageSimulator, setAgeSimulator] = useRecoilState(age);
  const [salarySimulator, setSalarySimulator] = useRecoilState(Salary);
  const [isPremiumClient, setISPremiumClient] = useRecoilState(PremiumClient);
  const [_DurationCredit, setDurationCredit] = useRecoilState(DurationCredit);
  const [_Salary, setSalary] = useRecoilState(Salary);
  const [_SNMG, setSNMG] = useRecoilState(SNMG);
  const [_age, setAge] = useRecoilState(age);
  const [showModal, setShowModal] = useRecoilState(modalState);

  const [isPremium, setIsPremium] = useState(false);
  const [company, setCompany] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  // console.log(showModal, modalState);
  const { t, i18n } = useTranslation();

  //todo: state hooks of simulator
  const [dateValue, setDateValue] = useState(dayjs("2000-08-18T21:11:54"));
  const [totalSimulatorUI, setTotalSimulatorUI] = useState(0);
  const [hamishUI, setHamishUI] = useState(0);

  //todo: references hooks of simulator
  const toast = useRef(null);
  const modalRef = useRef(null);

  const showSuccess = (msg) => {
    toast.current.show({
      severity: "success",
      summary: i18n.language === "fr" ? "Succès" : "نجاح",
      detail: msg,
      life: 3000,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        if (isVerified === false) {
          setShowModal(false);
          setIsPremium(false);
          // setCompany('');
          setIdentifier("");
          setIsVerified(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowModal, showModal]);

  const showWarn = (msg) => {
    toast.current.show({
      severity: "warn",
      summary: "Message d'avertissement",
      detail: msg,
      life: 3000,
    });
  };
  const showError = (msg) => {
    toast.current.show({
      severity: "error",
      summary: "Message d'erreur",
      detail: msg,
      life: 3000,
    });
  };
  const handleChange = (newValue) => {
    setDateValue(newValue);
  };
  const handlePremium = () => {
    setIsPremium(!isPremium);
    setIdentifier("");
    setIsVerified(false);
    setISPremiumClient(false); // Reset recoil state when toggling
  };
  const handleVerify = async () => {

    if (!isPremium && identifier === "") {
      return;
    }
    if (identifier === "" && isPremium) {
      showError(
        i18n.language === "fr"
          ? "Veuillez entrer un identifiant pour vérifier votre identité"
          : " الرجاء إدخال معرف ليتم التحقق"
      );
      return;
    }

    setIsVerifying(true);

    try {
      // Check if identifier matches premium code
      if (identifier === "BEA002") {
        setIsVerified(true);
        setISPremiumClient(true); // Set the recoil state as well
        showSuccess(
          i18n.language === "fr"
            ? "Vous êtes maintenant un Golden Client"
            : "انت الان عميل مميز"
        );
      } else {
        setIsVerified(false);
        setISPremiumClient(false); // Reset the recoil state
        showError(
          i18n.language === "fr"
            ? "Code invalide."
            : "رمز غير صالح٪"
        );
      }
    } catch (error) {
      setIsVerified(false);
      setISPremiumClient(false);
      showError(
        i18n.language === "fr"
          ? "Une erreur s'est produite lors de la vérification"
          : "حدث خطأ أثناء التحقق"
      );
    } finally {
      setIsVerifying(false);
    }
  };

  const simulatorUI = (values) => {
    var SNMG = _SNMG;
    var Duration = parseInt(values.duration);
    var Salary = values.salary;
    var isPremium = values.isPremiumClient;

    var today = new Date();
    var currentYear = moment(today).format("YYYY");
    var hamishEldjedia = 0;

    setSimulatorStateRecoil(true);
    
    // Use the verified premium status instead of form values
    if (isVerified && isPremium) {
      console.log("Premium client verified - setting premium status to true");
      setISPremiumClient(true);
    } else {
      console.log("Not premium client - setting premium status to false");
      setISPremiumClient(false);
    }



    // todo: calculer l'age
    var ageClient = currentYear - dateValue.year();
    if (ageClient < 18) {
      return showError(
        i18n.language === "fr"
          ? "Vous  devez avoir plus de 18 ans."
          : "يجب أن يكون سنك أكثر من 18 سنة."
      );
    } else if (ageClient > 70) {
      return showError(
        i18n.language === "fr"
          ? "Vous  devez avoir moins de 70 ans."
          : "يجب أن يكون سنك أقل من 70 سنة."
      );
    }
    setAge(ageClient);
    // todo: update recoil state
    setDurationSimulator(Duration);
    setSalarySimulator(Salary);
    setAgeSimulator(ageClient);
    // todo: Vérification de salaire
    if (Salary < SNMG * 1.5) {
      showError(
        "Votre salaire inférieur de le salaire minimum pour acheter les produits"
      );
    }
    setTotalSimulatorUI(Salary * 0.3 * Duration);
    let totalSimulatorUI = Salary * 0.3 * Duration;
    console.log("totalSimulatorUI", totalSimulatorUI > 150000);
    if (isVerified && isPremium) {
      // Premium clients pay 0% down payment
      setHamishUI(0);
    } else {
      if (totalSimulatorUI <= 150000) {
        setHamishUI(totalSimulatorUI * 0.1);
      } else {
        setHamishUI(150000 * 0.1);
      }
    }

  };

  //todo: Lottie function
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return showModal ? (
    <>
      <Toast ref={toast} />
      <div
        className={
          "justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
        }
      >
        <div ref={modalRef} className="relative w-max my-6 mx-auto max-w-3xl">
          {/*content*/}
          <Formik
            initialValues={{
              birthday: null,
              salary: salarySimulator,
              duration: durationSimulator.toString(),
              hamishEldjedia: null,
              isPremiumClient: isPremium,
              premiumCode: "",
              isVerified: false,
            }}
            onSubmit={(values) => {
              if (values.duration != null) {
                setDurationCredit(values.duration);
              }
              setSalarySimulator(values.salary);
              setSalary(values.salary);
              console.log("values", values);
              // simulator(values);
              if (values.salary >= 30000) {
                simulatorUI(values);
              } else {
                showError(
                  "Votre salaire inférieur de le salaire minimum pour acheter les produits"
                );
              }
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  {/*header*/}
                  <div
                    className={`flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t ${i18n.language === "ar" ? "flex-row-reverse" : ""
                      }`}
                  >
                    <h3 className="text-3xl">{t("simulator.title")}</h3>
                    <button
                      className="p-1 border-0 text-primary-color float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setShowModal(false)}
                    >
                      <span className="bg-transparent text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>

                  {/*body*/}
                  <div className="relative p-6 flex-auto">
                    {i18n.language === "fr" ? (
                      <Message
                        className="mb-5 font-bold"
                        severity="info"
                        text="Le total de votre commande ne doit pas dépasser 1 500 000 Da"
                      />
                    ) : (
                      <Message
                        className="mb-5 font-bold w-full"
                        severity="info"
                        text="يجب ألا يتجاوز إجمالي طلبك 1،500،000 دج"
                      />
                    )}

                    <Stack spacing={3}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {i18n.language === "fr" ? (
                          <label htmlFor="visitors">
                            {t("simulator.birthday")}
                          </label>
                        ) : (
                          <label htmlFor="visitors" className="text-right">
                            {t("simulator.birthday")}
                          </label>
                        )}


                        <Field name="birthday">
                          {({ field, form: { touched, errors }, meta }) => (
                            <>
                              <DesktopDatePicker
                                inputFormat="DD/MM/YYYY"
                                value={dateValue}
                                onChange={handleChange}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                              {meta.touched && meta.error && (
                                <div className="error text-red-500">
                                  {meta.error}
                                </div>
                              )}
                            </>
                          )}
                        </Field>
                        <div>
                          {i18n.language === "fr" ? (
                            <label htmlFor="visitors">
                              {t("simulator.salary")}
                            </label>
                          ) : (
                            <label
                              htmlFor="visitors"
                              className="text-right float-right"
                            >
                              {t("simulator.salary")}
                            </label>
                          )}


                          <Field name="salary">
                            {({ field, form: { touched, errors }, meta }) => (
                              <div>
                                <input
                                  type="number"
                                  id="salary"
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                  placeholder=""
                                  min={_SNMG * 1.5}
                                  // max={_SNMG}
                                  {...field}
                                  required
                                />
                                {meta.touched && meta.error && (
                                  <div className="error text-red-500">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>

                          {/* the premium ------------------------------------------------------------------------------------*/}

                          <Field name="isPremiumClient">
                            {({ field, form }) => (
                              <div className="w-full mt-4">
                                {/* Golden Client Toggle */}
                                <div
                                  className={`flex justify-between items-center cursor-pointer p-2 w-full border rounded-lg shadow-md transition-all duration-300 ${isPremium
                                      ? "bg-yellow-400 text-yellow-900 border-yellow-300"
                                      : "bg-white text-gray-800 hover:bg-gray-50 border-gray-200"
                                    }`}
                                  onClick={() => {
                                    handlePremium();
                                    form.setFieldValue(
                                      "isPremiumClient",
                                      !isPremium
                                    );
                                    if (!isPremium) {
                                      form.setFieldValue("premiumCode", "");
                                      form.setFieldValue("isVerified", false);
                                    }
                                  }}
                                  dir={i18n.language === "ar" ? "rtl" : "ltr"}
                                >
                                  <div
                                    className="flex items-center space-x-3"
                                    dir={i18n.language === "ar" ? "rtl" : "ltr"}
                                  >
                                    <div
                                      className={`w-6 h-6 flex items-center justify-center rounded-md border ${isPremium
                                          ? "bg-white border-yellow-600"
                                          : "border-gray-300"
                                        }`}
                                    >
                                      {isPremium && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-4 w-4 text-yellow-600"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                    <span className="text-sm font-semibold">
                                      {isPremium
                                        ? i18n.language === "fr"
                                          ? "Client Premium"
                                          : "عميل متميز"
                                        : i18n.language === "fr"
                                          ? "Client Premium"
                                          : "عميل متميز"}
                                    </span>
                                  </div>
                                </div>

                                {/* Identifier Verification Section */}
                                {isPremium && (
                                  <Field name="premiumCode">
                                    {({ field: codeField, form: codeForm }) => (
                                      <div
                                        className="p-5 mt-4 bg-white rounded-lg border border-yellow-200 shadow-md space-y-4 animate-fade-in"
                                        dir={
                                          i18n.language === "ar" ? "rtl" : "ltr"
                                        }
                                      >
                                        <div className="space-y-2">
                                          <label className="block text-sm font-medium text-yellow-800">
                                            {i18n.language === "fr"
                                              ? "Entrez votre identifiant"
                                              : "أدخل المعرف الخاص بك"}
                                          </label>
                                          <div className="flex space-x-2">
                                            <input
                                              {...codeField}
                                              type="text"
                                              placeholder={
                                                i18n.language === "fr"
                                                  ? "Code d'identification"
                                                  : "رمز التحقق"
                                              }
                                              // value={identifier} 
                                              onChange={(e) => {
                                                const value =
                                                  e.target.value.toUpperCase();
                                                setIdentifier(value);
                                                codeForm.setFieldValue(
                                                  "premiumCode",
                                                  value
                                                );
                                              }}
                                              className="block w-full pl-3 pr-3 py-2 text-base border-yellow-300 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 rounded-md shadow-sm"
                                            />

                                          </div>

                                        </div>
                                      </div>
                                    )}
                                  </Field>
                                )}
                              </div>
                            )}
                          </Field>

                          {/* the premium ------------------------------------------------------------------------------------*/}
                        </div>

                        <div>
                          {i18n.language === "fr" ? (
                            <label htmlFor="visitors">
                              {t("simulator.duration")}
                              {/* {` `}({t('simulator.month')}) */}
                            </label>
                          ) : (
                            <label
                              htmlFor="visitors"
                              className="text-right float-right"
                            >
                              {t("simulator.duration")}
                            </label>
                          )}

                          <ul
                            className={`items-center w-full text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white ${i18n.language === "ar" ? "flex-row-reverse" : ""
                              }`}
                          >
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                              <div className="flex items-center pl-3">
                                <Field
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                  type="radio"
                                  name="duration"
                                  value="12"
                                />
                                <label
                                  htmlFor="horizontal-list-radio-license"
                                  className="text-primery-color py-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                  {t("simulator.months12")}
                                </label>
                              </div>
                            </li>
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                              <div className="flex items-center pl-3">
                                <Field
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                  type="radio"
                                  name="duration"
                                  value="24"
                                />
                                <label
                                  htmlFor="horizontal-list-radio-license"
                                  className="text-primery-color py-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                  {t("simulator.months24")}
                                </label>
                              </div>
                            </li>
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                              <div className="flex items-center pl-3">
                                <Field
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                  type="radio"
                                  name="duration"
                                  value="36"
                                />
                                <label
                                  htmlFor="horizontal-list-radio-license"
                                  className="text-primery-color py-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                  {t("simulator.months36")}
                                </label>
                              </div>
                            </li>
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                              <div className="flex items-center pl-3">
                                <Field
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                  type="radio"
                                  name="duration"
                                  value="48"
                                />
                                <label
                                  htmlFor="horizontal-list-radio-license"
                                  className="text-primery-color py-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                  {t("simulator.months48")}
                                </label>
                              </div>
                            </li>
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                              <div className="flex items-center pl-3">
                                <Field
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                  type="radio"
                                  name="duration"
                                  value="60"
                                />
                                <label
                                  htmlFor="horizontal-list-radio-license"
                                  className="text-primery-color py-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300"
                                >
                                  {t("simulator.months60")}
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </LocalizationProvider>
                      {totalSimulatorUI > 0 ? (
                        <>
                          <hr />


                          <div>
                            {isVerified ? (
                              <>
                                <div className="flex items-center justify-center gap-2">
                                  <p className="text-center text-sm text-green-600">
                                    {i18n.language === "fr"
                                      ? "Vous êtes maintenant un Golden client "
                                      : "تم تطبيق خصم العميل  المميز"}
                                  </p>
                                  {/* <div className="bg-green-500 w-1 h-1  rounded-full   "></div> */}
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            {i18n.language === "fr" ? (

                              <article className="">

                                <Lottie
                                  options={defaultOptions}
                                  height={50}
                                  width={50}
                                />
                                {/*todo: Banque financement */}
                                <h6
                                  className="grid text-md font-bold"
                                  style={{ gridTemplateColumns: "300px 1fr" }}
                                >
                                  {t("simulator.CEmax")}:
                                  <span className={"text-right font-bold"}>
                                    {parseInt(
                                      totalSimulatorUI < 1500000
                                        ? totalSimulatorUI
                                        : 1500000
                                    ).toLocaleString("fr-FR")}
                                    .00 Da
                                  </span>
                                </h6>

                                {/*todo: hamish el jedia */}
                                <div
                                  className="grid"
                                  style={{ gridTemplateColumns: "200px 1fr" }}
                                >
                                  <h6 className="flex text-md font-bold">
                                    {t("simulator.Hamish")}:
                                    <div>
                                      <Tooltip target=".custom-target-icon" />

                                      <i
                                        className="custom-target-icon p-text-secondary p-overlay-badge"
                                        data-pr-tooltip="Le gage du sérieux"
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                        style={{
                                          fontSize: "2rem",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <img
                                          src={infoIcon}
                                          alt={"..."}
                                          width={"16px"}
                                          height={"16px"}
                                        />
                                      </i>
                                    </div>
                                  </h6>
                                  <h6
                                    className={"text-right text-md font-bold"}
                                  >
                                    {hamishUI.toLocaleString("fr-FR")}.00 Da
                                  </h6>
                                </div>
                              </article>
                            ) : (
                              <article className="md:border px-4 md:px-12 md:pb-6">
                                <Lottie
                                  options={defaultOptions}
                                  height={100}
                                  width={100}
                                />
                                {/*todo: Banque financement */}
                                <h6
                                  className="grid text-md font-bold"
                                  style={{ gridTemplateColumns: "300px 1fr" }}
                                >
                                  <span className={"text-left font-bold"}>
                                    {" "}
                                    دج{" "}
                                    {parseInt(
                                      totalSimulatorUI < 1500000
                                        ? totalSimulatorUI
                                        : 1500000
                                    ).toLocaleString("fr-FR")}
                                    .00{" "}
                                  </span>
                                  :{t("simulator.CEmax")}
                                </h6>
                                {/*todo: Banque financement */}
                                <h6
                                  className="grid text-md font-bold"
                                  style={{ gridTemplateColumns: "200px 1fr" }}
                                >
                                  <span className={"text-left font-bold"}>
                                    {" "}
                                    دج {hamishUI.toLocaleString(
                                      "fr-FR"
                                    )}.00{" "}
                                  </span>
                                  :{t("simulator.Hamish")}
                                </h6>
                              </article>
                            )}
                          </div>
                          <div>
                           
                            <div className="flex items-center gap-2 mt-3 p-3 rounded-md bg-yellow-50 border border-yellow-200 shadow-sm">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 text-yellow-500 flex-shrink-0"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 8v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
                                />
                              </svg>
                              <span className="text-xs text-yellow-800 font-medium">
                                {t("simulator.note") || "NB: le résultat est approximatif et ne représente pas le résultat final"}
                              </span>
                            </div>
                        </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </Stack>
                  </div>
                  {/*footer*/}
                  <div
                    className={`flex justify-between ${i18n.language === "ar" ? "flex-row-reverse" : ""
                      }`}
                  >
                    <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                      <Link
                        to="/products"
                        className="bg-primary-color hover:bg-secondary-color text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded-xl shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="submit"
                      >
                        {t("simulator.produits")}
                      </Link>
                    </div>
                    <div
                      className={`flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b ${i18n.language === "ar" ? "flex-row-reverse" : ""
                        }`}
                    >
                      <button
                        className="text-red-800 hover:text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => setShowModal(false)}
                      >
                        {/*Fermer*/}
                        {t("simulator.fermer")}
                      </button>
                      <button
                        className={` hover:bg-secondary-color text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded-xl shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 ${isPremium && identifier === "" ? "bg-gray-400" : "bg-primary-color"}`}
                        type="submit"
                        disabled={isPremium && identifier === ""}
                        onClick={() => {
                          if (!isVerified) {
                            handleVerify();
                          }
                        }}
                      >
                        {t("simulator.appliquer")}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  ) : (
    <div></div>
  );
}

export default Simulator;
